(() => {
    const SELECTOR = '[data-amara-faq]';

    function initFaq(section) {
        if (!section || section.dataset.amaraFaqReady === 'true') return;

        section.dataset.amaraFaqReady = 'true';
        section.classList.add('js-ready');

        const items = [...section.querySelectorAll('[data-amara-faq-item]')];

        const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;

        function getParts(item) {
            return {
                trigger: item.querySelector('[data-amara-faq-trigger]'),
                panel: item.querySelector('[data-amara-faq-panel]')
            };
        }

        function finishOpen(item, panel) {
            panel.style.height = 'auto';

            item.classList.add('is-open');
            panel.classList.add('is-open');

            panel.setAttribute('aria-hidden', 'false');
        }

        function openItem(item) {
            const { trigger, panel } = getParts(item);

            if (!trigger || !panel) return;
            if (trigger.getAttribute('aria-expanded') === 'true') return;

            items.forEach((otherItem) => {
                if (otherItem !== item) {
                    closeItem(otherItem);
                }
            });

            trigger.setAttribute('aria-expanded', 'true');

            panel.setAttribute('aria-hidden', 'false');

            item.classList.add('is-open');
            panel.classList.add('is-open');

            if (prefersReducedMotion) {
                panel.style.height = 'auto';
                return;
            }

            panel.style.height = '0px';

            requestAnimationFrame(() => {
                const targetHeight = panel.scrollHeight;

                panel.style.height = `${targetHeight}px`;

                const onTransitionEnd = (event) => {
                    if (event.propertyName !== 'height') return;

                    panel.removeEventListener('transitionend', onTransitionEnd);

                    if (trigger.getAttribute('aria-expanded') === 'true') {
                        finishOpen(item, panel);
                    }
                };

                panel.addEventListener('transitionend', onTransitionEnd);
            });
        }

        function closeItem(item) {
            const { trigger, panel } = getParts(item);

            if (!trigger || !panel) return;
            if (trigger.getAttribute('aria-expanded') !== 'true') return;

            trigger.setAttribute('aria-expanded', 'false');

            item.classList.remove('is-open');
            panel.classList.remove('is-open');

            if (prefersReducedMotion) {
                panel.style.height = '0px';
                panel.setAttribute('aria-hidden', 'true');
                return;
            }

            const currentHeight = panel.scrollHeight;

            panel.style.height = `${currentHeight}px`;

            requestAnimationFrame(() => {
                panel.style.height = '0px';

                const onTransitionEnd = (event) => {
                    if (event.propertyName !== 'height') return;

                    panel.removeEventListener('transitionend', onTransitionEnd);

                    if (trigger.getAttribute('aria-expanded') === 'false') {
                        panel.setAttribute('aria-hidden', 'true');
                    }
                };

                panel.addEventListener('transitionend', onTransitionEnd);
            });
        }

        items.forEach((item) => {
            const { trigger, panel } = getParts(item);

            if (!trigger || !panel) return;

            trigger.addEventListener('click', () => {
                const expanded = trigger.getAttribute('aria-expanded') === 'true';

                if (expanded) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
            });
        });


        /* =====================================================
           ENTRANCE REVEAL
           ===================================================== */

        const revealElements = [
            ...section.querySelectorAll('[data-amara-faq-reveal]')
        ];

        if (prefersReducedMotion || !('IntersectionObserver' in window)) {
            revealElements.forEach((element) => {
                element.classList.add('is-visible');
            });

            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;

                    const element = entry.target;

                    const itemIndex = items.indexOf(element);

                    if (itemIndex >= 0) {
                        element.style.transitionDelay = `${itemIndex * 55}ms`;
                    }

                    element.classList.add('is-visible');

                    observer.unobserve(element);
                });
            },
            {
                threshold: 0.12,
                rootMargin: '0px 0px -7% 0px'
            }
        );

        revealElements.forEach((element) => {
            observer.observe(element);
        });
    }


    function scan(root = document) {
        if (root.matches?.(SELECTOR)) {
            initFaq(root);
        }

        root.querySelectorAll?.(SELECTOR).forEach(initFaq);
    }


    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => scan());
    } else {
        scan();
    }


    /* Shopify Theme Editor support */

    document.addEventListener('shopify:section:load', (event) => {
        scan(event.target);
    });
})();